
import Component from "vue-class-component"
import Page from "@/report/pages/Page.vue"
import {format} from "date-fns"

@Component({name: "CoverPage"})
export default class CoverPage extends Page {
  get crm(): string {
    return this.report.contacts.providerContacts.find(
      c => c.title === "Relationship Manager"
    )!.name
  }

  get date(): string {
    return format(new Date(), "dd MMMM yyyy")
  }
}
